import { Directive, Input, SimpleChanges, ElementRef, AfterViewInit, OnChanges } from '@angular/core';

@Directive({
  selector: '[appBackgroundImageUrl]',
  exportAs: 'backgroundImageUrl',
})
export class BackgroundImageUrlDirective implements AfterViewInit, OnChanges {
  @Input('appBackgroundImageUrl') src: string;
  private el: HTMLElement;

  constructor(
    private elRef: ElementRef,
  ) { }

  ngAfterViewInit(): void {
    if (this.elRef) {
      this.el = this.elRef.nativeElement;
      this.setPresentSrcUrl();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.setPresentSrcUrl();
    }
  }

  private setPresentSrcUrl() {
    if (this.el) {
      this.el.style.backgroundImage = this.src ? `url('${this.src}')` : '';
    }
  }
}
